import { useAtom, useSetAtom } from "jotai";
import { selectedPeriodAtom } from "./metrics.state";
import RightSidebarButton from "@/features/Navigation/components/RightSidebarButton";
import { rightDrawerOpenAtom } from "@/features/Navigation/state";
import clsx from "clsx";
import { MetricLineage } from "./MetricLineage";
import { useMetricData } from "./useMetricData";

export function LineagedValuePanel() {
    const [selectedPeriod, setSelectedPeriod] = useAtom(selectedPeriodAtom);
    const setRightDrawerOpen = useSetAtom(rightDrawerOpenAtom);
    const { parsed } = useMetricData();
    const metric = parsed?.find((metric) => metric.period === selectedPeriod);

    if (!selectedPeriod || !metric) {
        return null;
    }

    return (
        <div
            className={clsx(
                "px-6",
                "custom-scrollbar absolute inset-0 flex min-h-0 flex-col overflow-hidden",
            )}
        >
            <div className="sticky my-4 flex flex-col">
                <RightSidebarButton
                    onClick={() => {
                        setRightDrawerOpen(false);
                        setSelectedPeriod(null);
                    }}
                />
                <>
                    <h2 className="pageheading ">
                        {selectedPeriod
                            .split(/<\d+>/)
                            .map((date) => date.split("-").reverse().join("/"))
                            .join(" - ")}
                    </h2>
                    <p className="body-s subdued mb-4">
                        Select a value to see the files that went into this
                        calculation.
                    </p>
                </>
            </div>
            <div className="custom-scrollbar hide-scrollbar overflow-y-scroll">
                <MetricLineage metric={metric} />
            </div>
        </div>
    );
}
